module.exports = __webpack_public_path__ + "media/images/homepage-74ff3e90afa62f72261ac087e9ee1c03.png";